<script setup lang="ts">
/**
 * Bridge component: Vue 2 compat → XCheckbox (Vue 3)
 *
 * Required while using @vue/compat in MODE: 2.
 * Once compat is removed, delete this file and map SwordCheckbox
 * directly to XCheckbox in global-components.ts
 *
 * Usage:
 *
 *   <sword-checkbox v-model="checked" @change="handleChange" />
 */
import { XCheckbox } from '@swordhealth/ui'

withDefaults(defineProps<{
  value?: boolean | string | number
  optValue?: boolean | string | number
}>(), {
  optValue: true,
})

const emit = defineEmits<{
  (e: 'input', value: boolean): void
  (e: 'change', value: boolean): void
}>()

const handleUpdate = (newValue: boolean) => {
  emit('input', newValue)
  emit('change', newValue)
}
</script>

<template>
  <x-checkbox
    v-bind="$attrs"
    :model-value="value"
    :opt-value="optValue"
    :vee-use-field="false"
    @update:model-value="handleUpdate"
  >
    <slot></slot>
  </x-checkbox>
</template>
